import { useTranslation } from 'react-i18next';
import { ImageIcon } from '@vlabs/icons';


export const DefaultCaption = () => {
  const { t } = useTranslation();
  const SUPPORTED_TYPES_FOR_CAPTION = ['jpeg', 'png', 'tiff'];

  return (
    <div className="FileDropzone__Caption">
      <ImageIcon />

      <span className="FileDropzone__CaptionTitle">
        {t('shared:перетащите файл или нажмите')}
      </span>

      <span className="FileDropzone__CaptionDescription">
        {t('checks:image checks.form.dropzone.supported types',
          { supportedTypes: SUPPORTED_TYPES_FOR_CAPTION.join(', ') }
        )}
      </span>
    </div>
  );
}
